import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'
import PropTypes from 'prop-types'
import { Form } from 'formsy-react-2'
import { Row } from 'react-flexbox-grid'
import { Button, Checkbox, Modal, Select, TextInput } from 'advenio-components'
import styled from 'styled-components'
import OriginalIsland from '../../Components/Island/Island'
import CompaniesActions from '../../Data/Redux/CompaniesRedux'

const Container = styled.div`
  margin-bottom: 24px;
`
const Island = styled(OriginalIsland).attrs({
  paddedBody: true,
  headingFontSize: 16,
})`
  margin-bottom: 24px;
  box-shadow: 0 4px 16px rgba(0,0,0, .15);
`
const InputContainer = styled.div`
  margin-bottom: 24px;
`
const HiddenInputContainer = styled.div`
  display: none;
`
const ButtonsContainer = styled(Row).attrs({
  end: 'xs',
})``

class OwnCenterDetails extends Component {
  state = {
    canSubmit: false,
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.successSave) {
      this.props.goBackToProfile()
    }
  }

  componentWillUnmount() {
    this.props.resetContract()
  }

  submitForm = (data) => {
    const payload = data

    payload.contract_type = 'Own Center'
    payload.products[0].students_limit = payload.students_limit
    delete payload.country_id

    this.props.storeContract(payload)
  }

  enableSubmit = () => this.setState({ canSubmit: true })

  disableSubmit = () => this.setState({ canSubmit: false })

  renderCenterOptions = () => {
    const formData = this.form && this.form.getModel()
    const countryId = formData && formData.country_id
    const { company: { available_centers: centers } } = this.props

    if (!centers || !countryId) return []

    return centers
      .filter(center => center.country_id == countryId)
      .map(center => ({
        id: center.id,
        label: center.name,
        value: center.id,
      }))
  }

  renderCountryOptions = () => {
    const { countries } = this.props

    if (!countries) return []

    return countries.map(country => ({
      id: country.id,
      label: country.name,
      value: country.id,
    }))
  }

  render() {
    const { loadingCenters, loadingCompany } = this.props
    const { canSubmit } = this.state
    const formData = this.form && this.form.getModel()

    return (
      <Container>
        {(loadingCompany || loadingCenters) && <Modal isOpened loading />}
        {!loadingCompany && (
          <Form
            ref={(el) => { this.form = el }}
            onValidSubmit={this.submitForm}
            onValid={this.enableSubmit}
            onInvalid={this.disableSubmit}
          >
            <h1>Centro Propio – {this.props.company.name}</h1>
            <Island heading="Datos Generales del Contrato">
              <InputContainer>
                <TextInput required type="text" id="name" name="name" label="Nombre del Contrato" />
              </InputContainer>
              <InputContainer>
                <Select
                  required
                  name="country_id"
                  label="¿En qué país se aplicará el contrato?"
                  options={this.renderCountryOptions()}
                  placeholder="Selecciona a un país"
                />
              </InputContainer>
            </Island>
            <Island heading="Costo para la empresa">
              <InputContainer>
                <TextInput
                  required
                  type="text"
                  id="fee"
                  name="fee"
                  label="Cuota Mensual"
                  help="Este es el monto que se cobrará a la empresa mensualmente"
                  prefix="$"
                  validations="isFloat"
                  validationErrors={{ isFloat: 'El monto debe ser un número' }}
                />
              </InputContainer>
              <InputContainer>
                <Checkbox
                  id="is_fixed_fee"
                  name="is_fixed_fee"
                  label="¿El precio será fijo mes por mes?"
                  help="Por lo pronto este campo no se puede desactivar"
                  disabled
                  value
                  large
                  invertedColors
                />
              </InputContainer>
              <InputContainer>
                <TextInput
                  type="text"
                  id="students_limit"
                  name="students_limit"
                  label="¿Cuál es el limite de niños que se pueden inscribir en el centro?"
                  help="Deja el campo en blanco si no hay limite"
                  validations="isInt"
                  validationErrors={{ isInt: 'El limite debe ser un número entero' }}
                />
              </InputContainer>
              <InputContainer>
                <Checkbox
                  id="subsidies_consumables"
                  name="subsidies_consumables"
                  label="¿La empresa quiere subsidiar el costo de los insumos que consumen los alumnos?"
                  value
                  large
                  invertedColors
                />
              </InputContainer>
              <InputContainer>
                <Checkbox
                  id="sibling_discount"
                  name="products.0.sibling_discount"
                  label="¿Habrá descuento por la inscripción de hermanos?"
                  large
                  invertedColors
                />
                <HiddenInputContainer>
                  <TextInput
                    type="text"
                    id="country_product_id"
                    name="products.0.country_product_id"
                    label="Country Product ID"
                    value={1}
                    validations="isInt"
                    validationErrors={{ isInt: 'El limite debe ser un número entero' }}
                    readOnly
                  />
                </HiddenInputContainer>
              </InputContainer>
            </Island>
            <Island heading="Centros">
              <InputContainer>
                <Select
                  required
                  name="center_id"
                  label="El centro al que aplica este contrato"
                  options={this.renderCenterOptions()}
                  placeholder={formData && formData.country_id ? 'Selecciona un centro' : 'Selecciona primero el país'}
                />
              </InputContainer>
            </Island>
            <ButtonsContainer>
              <Button type="submit" primary disabled={!canSubmit}>Guardar Contrato</Button>
            </ButtonsContainer>
          </Form>
        )}
      </Container>
    )
  }
}

OwnCenterDetails.propTypes = {
  /** The Company's profile data */
  company: PropTypes.object.isRequired,
  /** The array of countries where Advenio operates */
  countries: PropTypes.array.isRequired,
  /** Flag indicating that the Available Centers data is loading */
  loadingCenters: PropTypes.bool.isRequired,
  /** Flag indicating the Contract has been successfully stored in the API */
  successSave: PropTypes.bool.isRequired,
  /** Flag indicating that the Company data is loading */
  loadingCompany: PropTypes.bool.isRequired,
  /** Store a new Contract for this Company */
  storeContract: PropTypes.func.isRequired,
  /** Naviage back to the Company's profile page */
  goBackToProfile: PropTypes.func.isRequired,
  /** Reset the new contract redux store */
  resetContract: PropTypes.func.isRequired,
}

const mapStateToProps = ({ companies, countries }) => ({
  company: companies.getOne.result,
  countries: countries.get.results,
  loadingCenters: companies.getAvailableCenters.fetching,
  loadingCompany: companies.getOne.fetching,
  successSave: companies.newContract.success,
})

const mapDispatchToProps = (dispatch, { match: { params: { id } } }) => ({
  storeContract: payload => dispatch(CompaniesActions.contractCreateRequest(id, payload)),
  resetContract: () => dispatch(CompaniesActions.contractCreateReset()),
  goBackToProfile: () => dispatch(push(`/companies/${id}`)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OwnCenterDetails))



// WEBPACK FOOTER //
// ./src/Containers/AddContract/OwnCenterDetails.jsx